export enum FeatureFlag {
  INTERCOM_CONNEXION_UPGRADE = 'intercom_connexion_upgrade',
  DASHBOARD_PDF_EXPORT = 'dashboard_pdf_export',
  CAMPAIGN_MANAGER = 'WAL-1513-campaign_manager',
  ORGANIZATION_PERIMETERS_GROUP_BY = 'WAL_2120_organization_perimeters_group_by',
  PERMISSIONS_ON_MULTIPLE_NODES = 'WAL_1908_permissions_on_multiple_nodes',
  CAMPAIGN_EVAL_GROUP_BY = 'WAL_2354_campaign_eval_group_by',
}

export interface CustomerFeatureFlag {
  enable: boolean
  feature_flag: {
    id: number
    name: string
  }
  feature_flag_id: number
  id: number
}
